import Settore from "./Settore";
export default Settore;
